import { Space, Stack, Title } from '@mantine/core';
import { useRouter } from '@tanstack/react-router';

import { LBButton } from '@/shared/ui-kit/components';
import { Logo } from '@/shared/ui-kit/icons/Logo';

export const NotFoundPage = () => {
  const router = useRouter();
  return (
    <Stack>
      <Logo width={24} />
      <Space h={48} />
      <Title>Not Found Page </Title>
      <Space h={16} />
      <LBButton
        onClick={() => {
          router.history.back();
        }}
      >
        To Home
      </LBButton>
    </Stack>
  );
};
